import classNames from "../../../utils/classNames"

export const TextInput = ({
  label,
  register,
  registerName,
  disabled = false,
  type = "text",
  placeholder = "",
  richText = false,
  cols = "sm:col-span-1",
  customClasses = "",
  rows = 2,
  initialValue = "",
  maxLength = 524288,
  required = false,
  size = "md",
}) => {

  const sizeClasses = {
    sm: "px-2 py-1 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base"
  }

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-500">
        {label}{required && <span className="text-primary-500">*</span>}
      </label>
      {
        richText ?
          <textarea
            {...register(registerName)}
            disabled={disabled}
            className={classNames(
              disabled ? "bg-gray-300" : "", 
              `w-full mt-1 text-gray-900 border-1 border-gray-300 ${sizeClasses[size]} ${customClasses}`
            )}
            rows={rows}
            defaultValue={initialValue}
            required={required}
          />
          :
          <input
            {...register(registerName)}
            disabled={disabled}
            type={type}
            placeholder={placeholder}
            className={classNames(
              disabled ? "bg-gray-300" : "", 
              `w-full mt-1 text-gray-900 border-1 border-gray-300 ${sizeClasses[size]} ${customClasses}`
            )}
            defaultValue={initialValue}
            maxLength={maxLength}
            required={required}
          />
      }
    </div>
  )
}